import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityPrimitiveColorTokens } from '../unityTokens';
import { grey } from './colors';

export const greyOption = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['grey'] => {
  if (opts.panwRebrandStubYear) {
    const p = unityPrimitiveColorTokens;
    return mode === 'light'
      ? {
          50: p['--color-charcoal-50'],
          100: p['--color-charcoal-100'],
          200: p['--color-charcoal-300'],
          300: p['--color-charcoal-400'],
          400: p['--color-charcoal-500'],
          500: p['--color-charcoal-600'],
          600: p['--color-charcoal-700'],
          700: p['--color-charcoal-800'],
          800: p['--color-charcoal-900'],
          900: p['--color-charcoal-1000'],
          950: p['--color-charcoal-1000'],
        }
      : // Reverse greys from darkest to lightest for Dark mode
        {
          50: p['--color-charcoal-1000'],
          100: p['--color-charcoal-1000'],
          200: p['--color-charcoal-900'],
          300: p['--color-charcoal-800'],
          400: p['--color-charcoal-700'],
          500: p['--color-charcoal-600'],
          600: p['--color-charcoal-500'],
          700: p['--color-charcoal-400'],
          800: p['--color-charcoal-300'],
          900: p['--color-charcoal-100'],
          950: p['--color-charcoal-50'],
        };
  }

  return mode === 'light'
    ? {
        50: grey[50],
        100: grey[100],
        200: grey[200],
        300: grey[300],
        400: grey[400],
        500: grey[500],
        600: grey[600],
        700: grey[700],
        800: grey[800],
        900: grey[900],
        950: grey[950],
      }
    : // Reverse greys from darkest to lightest for Dark mode
      {
        50: grey[950],
        100: grey[900],
        200: grey[800],
        300: grey[700],
        400: grey[600],
        500: grey[500],
        600: grey[400],
        700: grey[300],
        800: grey[200],
        900: grey[100],
        950: grey[50],
      };
};
